import React, { useState } from "react";
import log from "cslog";
import { Button, Form, Input, Space } from "antd";
import { useGenMultipage } from "../../_actions/bot";

const { TextArea } = Input;

function BookAI({ item, onBookGenerate = () => {} }) {
    const [userQuery, setUserQuery] = useState("");
    const mutationGen = useGenMultipage((result) => {
        log.d(result, "result in BookAI");
        const mapping = item?.others?.presetPageMapping || {};
        log.d(mapping, "mapping in BookAI");
        if (result?.success) {
            const out = [];
            result?.data?.forEach((item) => {
                const page_id = mapping[item.preset];
                out.push({
                    render_page: page_id,
                    prefill: {
                        [item.preset]: item?.value || {},
                    },
                });
            });
            onBookGenerate(out);
        }
    });

    log.d(item, "item in BookAI");

    const generate = () => {
        mutationGen.mutate({
            user_prompt: userQuery,
        });
        return;
        onBookGenerate([
            {
                render_page: "q_y4_0NCKCIT",
                prefill: {
                    heading_and_content: {
                        heading: "Sun is a star",
                        content: "Science",
                    },
                },
            },
            {
                render_page: "q_vU97zwjVIv",
                prefill: {
                    fact: {
                        fact: "The moon is a planet",
                        source: "Science",
                    },
                },
            },
            {
                render_page: "q_vU97zwjVIv",
                prefill: {
                    fact: {
                        fact: "The earth is a planet",
                        source: "Science",
                    },
                },
            },
            {
                render_page: "q_WnfIYbbdfd",
                prefill: {
                    quote: {
                        quote: "Never give up man",
                        author: "someone wise",
                    },
                },
            },
            {
                render_page: "q_WnfIYbbdfd",
                prefill: {
                    quote: {
                        quote: "You can't get much done in life if you only work on days when you feel good.",
                        author: "some wise person",
                    },
                },
            },
            {
                render_page: "q_vU97zwjVIv",
                prefill: {
                    fact: {
                        fact: "The best thing about universe is that it is infinite",
                        source: "Science backed",
                    },
                },
            },
        ]);
    };
    return (
        <div>
            <h3>Book AI</h3>

            <Form layout="vertical">
                <Form.Item label="What do you want to write book about">
                    <TextArea
                        value={userQuery}
                        onChange={(e) => setUserQuery(e.target.value)}
                    />
                </Form.Item>
                <Space>
                    <Button
                        type="primary"
                        onClick={generate}
                        loading={mutationGen.isLoading}
                    >
                        Generate
                    </Button>
                    <Button onClick={() => onBookGenerate([])}>Reset</Button>
                </Space>
            </Form>
        </div>
    );
}

export default BookAI;
